import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/member-loyalty-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const memberReport = require("./MemberReport").default;
          cb(null, memberReport);
        },
        "FraudReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/MemberReport/index.js